<template>
  <div class="banner">
    <img class="banner-img" :src="data.img">
    <p class="banner-title-ch">{{data.titleCh}}</p>
    <p class="banner-title-en">{{data.titleEn}}</p>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {}
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  width: 100%; height: 360px;
  margin-top: 67px;
  background: url('https://static001.geekbang.org/resource/image/a3/ac/a3fa147668e732c5508f49b4807aa5ac.png') center / cover no-repeat;

  @include mobile {
    width: 100vw; height: 45.6vw;
    margin-top: 44px;
    background: url('https://static001.geekbang.org/resource/image/0f/2f/0f495311e4eda12dc5e370c8f15e9e2f.png') center / cover no-repeat;
  }
}

.banner-img {
  width: 120px; height: 120px;

  @include mobile {
    width: 60px; height: 60px;
  }
}

.banner-title-ch {
  margin-top: 14px;
  color: #000000;
  font-size: 46px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 63px;

  @include mobile {
    margin-top: 10px;
    font-size: 22px;
    line-height: 1;
  }
}

.banner-title-en {
  margin-top: 11px;
  color: #303030;
  font-size: 31px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 43px;
  letter-spacing: 1px;

  @include mobile {
    margin-top: 9px;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
